import Result from './result';

export default Result;
export type * from './types';
